import AsyncStorage from '@react-native-async-storage/async-storage';
let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
 
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
  StatusBar,
  Image,
  TextInput,
  FlatList,
  RefreshControl,
  ActivityIndicator,
} from 'react-native';
import { Ionicons, FontAwesome5, MaterialIcons } from '@expo/vector-icons';
import { apiFetch } from '../../utils/apiClient';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
// JOBENG Logo component
const JobengLogo = () => (
  <Image
    source={require('../../../assets/jobeng_icon.png')}
    style={{ width: 30, height: 30 }}
    resizeMode="contain"
  />
);

export default function MentorshipProgramsScreen({ navigation }) {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_mentorshipprogramsscreen`;
    apiFetch('/api/data/customers?sort=created_at&order=desc&limit=20').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  // States
  const [isLoading, setIsLoading] = useState(true);
  const [programs, setPrograms] = useState([]);
  const [filteredPrograms, setFilteredPrograms] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [selectedSort, setSelectedSort] = useState('Relevance');
  const [error, setError] = useState(null);

  // Mock data for mentorship programs
  const mockPrograms = [
    {
      id: '1',
      title: 'Engineering Leadership Mentorship',
      organization: 'Women in Engineering UK',
      field: 'Engineering',
      duration: '6 months',
      format: 'One-on-one',
      description:
        'Connect with experienced engineering leaders who will guide you through the early stages of your career. This program focuses on technical skill development, leadership capabilities, and career planning.',
      benefits: [
        'Personalized guidance from industry experts',
        'Technical skill development',
        'Leadership training',
        'Career planning support',
        'Networking opportunities',
      ],
      eligibility: [
        'Early career engineers (0-3 years experience)',
        'Bachelor s degree in Engineering or related field',
        'UK-based professionals',
      ],
      applicationDeadline: '2025-07-15',
      startDate: '2025-08-01',
      logo: 'https://example.com/wie-logo.png',
      isVirtual: true,
      isFree: true,
      commitment: '4-6 hours per month',
      mentors: [
        {
          name: 'Sarah Johnson',
          title: 'Chief Engineer at Rolls-Royce',
          experience: '20+ years',
          expertise: 'Aerospace Engineering, Leadership',
        },
        {
          name: 'Michael Chen',
          title: 'Technical Director at Arup',
          experience: '15+ years',
          expertise: 'Civil Engineering, Project Management',
        },
      ],
    },
    {
      id: '2',
      title: 'Tech Start Mentorship Program',
      organization: 'TechUK',
      field: 'Technology',
      duration: '12 months',
      format: 'Group and one-on-one',
      description:
        'A comprehensive mentorship program designed to help early career tech professionals navigate the industry. Includes both group sessions and one-on-one mentoring with experienced tech leaders.',
      benefits: [
        'Access to senior tech professionals',
        'Monthly group workshops',
        'Individual career coaching',
        'Industry networking events',
        'Resume and interview preparation',
      ],
      eligibility: [
        'Early career tech professionals (0-2 years experience)',
        'Background in Computer Science, Software Engineering, or related fields',
        'Currently employed in a tech role',
      ],
      applicationDeadline: '2025-06-30',
      startDate: '2025-07-15',
      logo: 'https://example.com/techuk-logo.png',
      isVirtual: true,
      isFree: false,
      cost: '£250 (scholarships available)',
      commitment: '8 hours per month',
      mentors: [
        {
          name: 'David Wilson',
          title: 'CTO at Monzo',
          experience: '18+ years',
          expertise: 'Software Architecture, FinTech',
        },
        {
          name: 'Priya Sharma',
          title: 'Engineering Manager at Google',
          experience: '12+ years',
          expertise: 'Cloud Computing, Team Leadership',
        },
      ],
    },
    {
      id: '3',
      title: 'Finance Career Accelerator',
      organization: 'London Finance Network',
      field: 'Finance',
      duration: '9 months',
      format: 'One-on-one',
      description:
        'Pair with experienced finance professionals who will help you navigate the early stages of your finance career. Focus on technical skills, industry knowledge, and career advancement strategies.',
      benefits: [
        'One-on-one mentoring with finance leaders',
        'Industry-specific guidance',
        'Professional certification advice',
        'Career path planning',
        'Access to exclusive industry events',
      ],
      eligibility: [
        'Early career finance professionals (0-3 years experience)',
        'Degree in Finance, Accounting, Economics, or related field',
        'Currently working in financial services',
      ],
      applicationDeadline: '2025-08-15',
      startDate: '2025-09-01',
      logo: 'https://example.com/lfn-logo.png',
      isVirtual: false,
      isFree: false,
      cost: '£350',
      commitment: '6-8 hours per month',
      mentors: [
        {
          name: 'James Thompson',
          title: 'Investment Director at Barclays',
          experience: '22+ years',
          expertise: 'Investment Banking, Asset Management',
        },
        {
          name: 'Emma Roberts',
          title: 'Finance Director at PwC',
          experience: '15+ years',
          expertise: 'Corporate Finance, Audit',
        },
      ],
    },
    {
      id: '4',
      title: 'Healthcare Professionals Mentoring',
      organization: 'NHS Leadership Academy',
      field: 'Healthcare',
      duration: '12 months',
      format: 'One-on-one and group',
      description:
        'A structured mentoring program for early career healthcare professionals looking to develop clinical excellence and leadership skills within the NHS and broader healthcare sector.',
      benefits: [
        'Guidance from senior healthcare professionals',
        'Clinical skills development',
        'Leadership and management training',
        'Career progression planning',
        'Work-life balance support',
      ],
      eligibility: [
        'Healthcare professionals with 1-4 years experience',
        'Currently working in the NHS or related healthcare organizations',
        'Commitment to healthcare leadership',
      ],
      applicationDeadline: '2025-07-30',
      startDate: '2025-09-15',
      logo: 'https://example.com/nhs-leadership-logo.png',
      isVirtual: false,
      isFree: true,
      commitment: '5-7 hours per month',
      mentors: [
        {
          name: 'Dr. Elizabeth Taylor',
          title: "Clinical Director, Guy's and St Thomas' NHS Trust",
          experience: '25+ years',
          expertise: 'Clinical Leadership, Healthcare Management',
        },
        {
          name: 'Dr. Rajiv Patel',
          title: 'Medical Director, University College London Hospitals',
          experience: '20+ years',
          expertise: 'Medical Education, Clinical Excellence',
        },
      ],
    },
    {
      id: '5',
      title: 'Creative Industries Mentorship',
      organization: 'Creative UK',
      field: 'Creative',
      duration: '6 months',
      format: 'One-on-one',
      description:
        'Connect with established professionals in the creative industries who will provide guidance on portfolio development, networking, and career growth in design, media, advertising, and related fields.',
      benefits: [
        'Portfolio review and development',
        'Industry connections',
        'Freelance business advice',
        'Project feedback',
        'Creative career planning',
      ],
      eligibility: [
        'Early career creative professionals (0-3 years experience)',
        'Background in design, media, advertising, or related fields',
        'Portfolio of work',
      ],
      applicationDeadline: '2025-06-15',
      startDate: '2025-07-01',
      logo: 'https://example.com/creative-uk-logo.png',
      isVirtual: true,
      isFree: false,
      cost: '£200',
      commitment: '4-5 hours per month',
      mentors: [
        {
          name: 'Alex Turner',
          title: 'Creative Director at WPP',
          experience: '18+ years',
          expertise: 'Advertising, Brand Strategy',
        },
        {
          name: 'Olivia Martinez',
          title: 'Design Lead at BBC',
          experience: '12+ years',
          expertise: 'UX/UI Design, Digital Media',
        },
      ],
    },
    {
      id: '6',
      title: 'Data Science Career Mentorship',
      organization: 'Data Science UK',
      field: 'Data Science',
      duration: '8 months',
      format: 'One-on-one and group',
      description:
        'A comprehensive mentorship program for early career data scientists and analysts. Receive guidance on technical skills, project work, and career development from experienced data professionals.',
      benefits: [
        'Technical skill development',
        'Project guidance and feedback',
        'Career path planning',
        'Industry best practices',
        'Networking with data professionals',
      ],
      eligibility: [
        'Early career data scientists or analysts (0-2 years experience)',
        'Background in Data Science, Statistics, Computer Science, or related fields',
        'Basic programming skills (Python, R)',
      ],
      applicationDeadline: '2025-08-01',
      startDate: '2025-09-01',
      logo: 'https://example.com/data-science-uk-logo.png',
      isVirtual: true,
      isFree: false,
      cost: '£300 (scholarships available)',
      commitment: '6-8 hours per month',
      mentors: [
        {
          name: 'Thomas Wright',
          title: 'Lead Data Scientist at Deliveroo',
          experience: '10+ years',
          expertise: 'Machine Learning, Data Engineering',
        },
        {
          name: 'Sophia Lee',
          title: 'AI Research Lead at DeepMind',
          experience: '8+ years',
          expertise: 'Artificial Intelligence, Neural Networks',
        },
      ],
    },
    {
      id: '7',
      title: 'Women in STEM Mentorship',
      organization: 'STEM Women UK',
      field: 'STEM',
      duration: '12 months',
      format: 'One-on-one and group',
      description:
        'A mentorship program specifically designed to support women in the early stages of their STEM careers. Includes one-on-one mentoring, group workshops, and networking events.',
      benefits: [
        'Support from experienced women in STEM',
        'Career development guidance',
        'Confidence building',
        'Networking opportunities',
        'Work-life balance strategies',
      ],
      eligibility: [
        'Women in early career STEM roles (0-5 years experience)',
        'Background in Science, Technology, Engineering, or Mathematics',
        'Commitment to advancing women in STEM',
      ],
      applicationDeadline: '2025-07-15',
      startDate: '2025-08-15',
      logo: 'https://example.com/stem-women-logo.png',
      isVirtual: true,
      isFree: true,
      commitment: '5-6 hours per month',
      mentors: [
        {
          name: 'Dr. Katherine Johnson',
          title: 'Research Director at GSK',
          experience: '20+ years',
          expertise: 'Pharmaceutical Research, Team Leadership',
        },
        {
          name: 'Dr. Maria Rodriguez',
          title: 'Professor of Computer Science, Imperial College London',
          experience: '15+ years',
          expertise: 'Computer Science, Academic Research',
        },
      ],
    },
    {
      id: '8',
      title: 'Graduate to Professional Mentorship',
      organization: 'UK Graduate Association',
      field: 'Cross-industry',
      duration: '6 months',
      format: 'One-on-one',
      description:
        'A mentorship program designed specifically for recent graduates transitioning into professional roles. Receive guidance on workplace navigation, professional development, and career planning.',
      benefits: [
        'Transition support from university to workplace',
        'Professional skills development',
        'Workplace navigation guidance',
        'Goal setting and career planning',
        'Professional network building',
      ],
      eligibility: [
        'Recent graduates (within last 2 years)',
        'Currently in first professional role or seeking employment',
        'Any degree discipline',
      ],
      applicationDeadline: '2025-06-30',
      startDate: '2025-07-15',
      logo: 'https://example.com/ukga-logo.png',
      isVirtual: true,
      isFree: true,
      commitment: '4 hours per month',
      mentors: [
        {
          name: 'Robert Clarke',
          title: 'HR Director at Unilever',
          experience: '15+ years',
          expertise: 'Professional Development, Career Coaching',
        },
        {
          name: 'Natalie Wong',
          title: 'Senior Manager at Deloitte',
          experience: '10+ years',
          expertise: 'Graduate Development, Professional Skills',
        },
      ],
    },
  ];

  // Filter options
  const filterOptions = [
    'All',
    'Engineering',
    'Technology',
    'Finance',
    'Healthcare',
    'Creative',
    'Data Science',
    'STEM',
    'Cross-industry',
    'Free',
    'Virtual',
  ];

  // Sort options
  const sortOptions = ['Relevance', 'Application Deadline', 'Duration'];

  // Load programs when component mounts
  useEffect(() => {
    loadPrograms();
  }, []);

  // Load programs
  const loadPrograms = () => {
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      try {
        setPrograms(mockPrograms);
        setFilteredPrograms(mockPrograms);
        setError(null);
      } catch (err) {
        setError('Failed to load mentorship programs');
        console.error('Error loading programs:', err);
      } finally {
        setIsLoading(false);
      }
    }, 1000);
  };

  // Handle search
  useEffect(() => {
    if (searchQuery.trim() === '') {
      applyFilters(selectedFilter, selectedSort);
    } else {
      const query = searchQuery.toLowerCase();
      const filtered = programs.filter(
        program =>
          String(program.title ?? '').toLowerCase().includes(query) ||
          String(program.organization ?? '').toLowerCase().includes(query) ||
          String(program.field ?? '').toLowerCase().includes(query) ||
          String(program.description ?? '').toLowerCase().includes(query)
      );
      setFilteredPrograms(sortPrograms(filtered, selectedSort));
    }
  }, [searchQuery, selectedFilter, selectedSort, programs]);

  // Apply filters
  const applyFilters = (filter, sort) => {
    setSelectedFilter(filter);
    setSelectedSort(sort);

    let filtered = [...programs];

    // Apply category filter
    if (filter !== 'All') {
      if (filter === 'Free') {
        filtered = filtered.filter(program => program.isFree);
      } else if (filter === 'Virtual') {
        filtered = filtered.filter(program => program.isVirtual);
      } else {
        filtered = filtered.filter(program => program.field === filter);
      }
    }

    // Apply sort
    filtered = sortPrograms(filtered, sort);

    setFilteredPrograms(filtered);
  };

  // Sort programs
  const sortPrograms = (programs, sortBy) => {
    const sorted = [...programs];

    switch (sortBy) {
      case 'Application Deadline':
        return sorted.sort(
          (a, b) =>
            new Date(a.applicationDeadline) - new Date(b.applicationDeadline)
        );
      case 'Duration':
        return sorted.sort((a, b) => {
          const aDuration = parseInt(a.duration.split(' ')[0]);
          const bDuration = parseInt(b.duration.split(' ')[0]);
          return bDuration - aDuration;
        });
      case 'Relevance':
      default:
        return sorted;
    }
  };

  // Format date
  const formatDate = dateString => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  // Calculate days until deadline
  const getDaysUntilDeadline = deadline => {
    const today = new Date();
    const deadlineDate = new Date(deadline);
    const diffTime = deadlineDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  };

  // Render program item
  const renderProgramItem = ({ item }) => {
    const daysUntilDeadline = getDaysUntilDeadline(item.applicationDeadline);
    const isUrgent = daysUntilDeadline <= 14 && daysUntilDeadline > 0;
    const isPast = daysUntilDeadline < 0;

    return (
      <TouchableOpacity
        style={styles.programCard}
        onPress={() =>
          navigation.navigate('MentorshipProgramDetails', {
            programId: item.id,
          })
        }
      >
        <View style={styles.cardHeader}>
          <View style={styles.headerInfo}>
            <Text style={styles.programTitle}>{item.title}</Text>
            <Text style={styles.programOrganization}>{item.organization}</Text>
          </View>
        </View>

        <View style={styles.cardDetails}>
          <View style={styles.detailItem}>
            <Ionicons name="business-outline" size={16} color="#64748B" />
            <Text style={styles.detailText}>{item.field}</Text>
          </View>

          <View style={styles.detailItem}>
            <Ionicons name="time-outline" size={16} color="#64748B" />
            <Text style={styles.detailText}>{item.duration}</Text>
          </View>

          <View style={styles.detailItem}>
            <Ionicons name="people-outline" size={16} color="#64748B" />
            <Text style={styles.detailText}>{item.format}</Text>
          </View>

          <View style={styles.detailItem}>
            <Ionicons name="calendar-outline" size={16} color="#64748B" />
            <Text style={styles.detailText}>
              Starts: {formatDate(item.startDate)}
            </Text>
          </View>

          <View style={styles.badgeContainer}>
            {item.isVirtual && (
              <View style={[styles.badge, styles.virtualBadge]}>
                <Text style={styles.virtualBadgeText}>Virtual</Text>
              </View>
            )}
            {item.isFree ? (
              <View style={[styles.badge, styles.freeBadge]}>
                <Text style={styles.freeBadgeText}>Free</Text>
              </View>
            ) : (
              <View style={[styles.badge, styles.paidBadge]}>
                <Text style={styles.paidBadgeText}>{item.cost}</Text>
              </View>
            )}
            <View style={[styles.badge, styles.commitmentBadge]}>
              <Text style={styles.commitmentBadgeText}>{item.commitment}</Text>
            </View>
          </View>
        </View>

        <Text numberOfLines={2} style={styles.programDescription}>
          {item.description}
        </Text>

        <View style={styles.mentorsContainer}>
          <Text style={styles.mentorsTitle}>Featured Mentors:</Text>
          <View style={styles.mentorsList}>
            {item.mentors.map((mentor, index) => (
              <View key={index} style={styles.mentorItem}>
                <View style={styles.mentorAvatar}>
                  <Text style={styles.mentorInitials}>
                    {mentor.name
                      .split(' ')
                      .map(n => n[0])
                      .join('')}
                  </Text>
                </View>
                <View style={styles.mentorInfo}>
                  <Text style={styles.mentorName}>{mentor.name}</Text>
                  <Text style={styles.mentorTitle}>{mentor.title}</Text>
                </View>
              </View>
            ))}
          </View>
        </View>

        <View style={styles.cardFooter}>
          <View style={styles.deadlineContainer}>
            <Text style={styles.deadlineLabel}>Application Deadline:</Text>
            <Text
              style={[
                styles.deadlineDate,
                isUrgent && styles.urgentDeadline,
                isPast && styles.pastDeadline,
              ]}
            >
              {formatDate(item.applicationDeadline)}
              {isUrgent && !isPast && ` (${daysUntilDeadline} days left)`}
              {isPast && ' (Closed)'}
            </Text>
          </View>

          <TouchableOpacity
            style={[styles.applyButton, isPast && styles.disabledButton]}
            disabled={isPast}
            onPress={() =>
              navigation.navigate('MentorshipApplication', {
                programId: item.id,
              })
            }
          >
            <Text style={styles.applyButtonText}>
              {isPast ? 'Closed' : 'Apply'}
            </Text>
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    );
  };

  // Render filter chip
  const renderFilterChip = filter => (
    <TouchableOpacity
      key={filter}
      style={[
        styles.filterChip,
        selectedFilter === filter && styles.activeFilterChip,
      ]}
      onPress={() => applyFilters(filter, selectedSort)}
    >
      <Text
        style={[
          styles.filterChipText,
          selectedFilter === filter && styles.activeFilterChipText,
        ]}
      >
        {filter}
      </Text>
    </TouchableOpacity>
  );

  return (
    <SafeAreaView style={styles.safeArea}>
      <StatusBar barStyle="light-content" backgroundColor="#0e4e96" />

      {/* Header */}
      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <Ionicons name="arrow-back" size={24} color="#ffffff" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Mentorship Programs</Text>
        <JobengLogo />
      </View>

      {/* Search Bar */}
      <View style={styles.searchContainer}>
        <View style={styles.searchBar}>
          <Ionicons
            name="search"
            size={20}
            color="#64748B"
            style={styles.searchIcon}
          />
          <TextInput
            style={styles.searchInput}
            placeholder="Search programs, organizations, fields..."
            placeholderTextColor="#94A3B8"
            value={searchQuery}
            onChangeText={setSearchQuery}
          />
          {searchQuery.length > 0 && (
            <TouchableOpacity
              style={styles.clearButton}
              onPress={() => setSearchQuery('')}
            >
              <Ionicons name="close-circle" size={18} color="#64748B" />
            </TouchableOpacity>
          )}
        </View>
      </View>

      {/* Filters */}
      <View style={styles.filtersContainer}>
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={styles.filtersScrollContent}
        >
          {filterOptions.map(renderFilterChip)}
        </ScrollView>

        <TouchableOpacity
          style={styles.sortButton}
          onPress={() => {
            // In a real app, this would open a sort modal or dropdown
            // For this example, we'll just cycle through sort options
            const currentIndex = sortOptions.indexOf(selectedSort);
            const nextIndex = (currentIndex + 1) % sortOptions.length;
            applyFilters(selectedFilter, sortOptions[nextIndex]);
          }}
        >
          <Ionicons name="options-outline" size={20} color="#0e4e96" />
          <Text style={styles.sortButtonText}>Sort: {selectedSort}</Text>
        </TouchableOpacity>
      </View>

      {/* Content */}
      {isLoading ? (
        <View style={styles.loadingContainer}>
          <ActivityIndicator size={36} color="#0e4e96" />
          <Text style={styles.loadingText}>Loading mentorship programs...</Text>
        </View>
      ) : error ? (
        <View style={styles.errorContainer}>
          <Ionicons name="alert-circle-outline" size={60} color="#dc2626" />
          <Text style={styles.errorTitle}>Error</Text>
          <Text style={styles.errorDescription}>{error}</Text>
          <TouchableOpacity style={styles.retryButton} onPress={loadPrograms}>
            <Text style={styles.retryButtonText}>Retry</Text>
          </TouchableOpacity>
        </View>
      ) : (
        <FlatList
          data={filteredPrograms}
          renderItem={renderProgramItem}
          keyExtractor={item => item.id}
          contentContainerStyle={styles.listContainer}
          showsVerticalScrollIndicator={false}
          ListEmptyComponent={
            <View style={styles.emptyContainer}>
              <Ionicons name="people-outline" size={60} color="#94A3B8" />
              <Text style={styles.emptyTitle}>
                No mentorship programs found
              </Text>
              <Text style={styles.emptyDescription}>
                Try adjusting your search or filters to find more opportunities
              </Text>
            </View>
          }
        />
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#F8FAFC',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#0e4e96',
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  backButton: {
    padding: 8,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#ffffff',
  },
  searchContainer: {
    backgroundColor: '#ffffff',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  searchBar: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F1F5F9',
    borderRadius: 8,
    paddingHorizontal: 12,
  },
  searchIcon: {
    marginRight: 8,
  },
  searchInput: {
    flex: 1,
    height: 40,
    fontSize: 16,
    color: '#0F172A',
  },
  clearButton: {
    padding: 4,
  },
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
    backgroundColor: '#ffffff',
  },
  filtersScrollContent: {
    paddingHorizontal: 16,
  },
  filterChip: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    backgroundColor: '#F1F5F9',
    marginRight: 8,
  },
  activeFilterChip: {
    backgroundColor: '#0e4e96',
  },
  filterChipText: {
    fontSize: 14,
    color: '#64748B',
    fontWeight: '500',
  },
  activeFilterChipText: {
    color: '#ffffff',
  },
  sortButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
  },
  sortButtonText: {
    fontSize: 14,
    color: '#0e4e96',
    fontWeight: '500',
    marginLeft: 4,
  },
  listContainer: {
    padding: 16,
  },
  programCard: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    marginBottom: 16,
    padding: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 5,
    elevation: 2,
  },
  cardHeader: {
    flexDirection: 'row',
    marginBottom: 12,
  },
  headerInfo: {
    flex: 1,
  },
  programTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#0F172A',
    marginBottom: 4,
  },
  programOrganization: {
    fontSize: 14,
    color: '#64748B',
  },
  cardDetails: {
    marginBottom: 12,
  },
  detailItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 6,
  },
  detailText: {
    fontSize: 14,
    color: '#64748B',
    marginLeft: 8,
  },
  badgeContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 8,
  },
  badge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    marginRight: 8,
    marginBottom: 4,
  },
  virtualBadge: {
    backgroundColor: '#0ea5e9' + '20',
  },
  virtualBadgeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#0ea5e9',
  },
  freeBadge: {
    backgroundColor: '#10b981' + '20',
  },
  freeBadgeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#10b981',
  },
  paidBadge: {
    backgroundColor: '#f59e0b' + '20',
  },
  paidBadgeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#f59e0b',
  },
  commitmentBadge: {
    backgroundColor: '#8b5cf6' + '20',
  },
  commitmentBadgeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#8b5cf6',
  },
  programDescription: {
    fontSize: 14,
    color: '#334155',
    marginBottom: 16,
    lineHeight: 20,
  },
  mentorsContainer: {
    marginBottom: 16,
  },
  mentorsTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: 8,
  },
  mentorsList: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  mentorItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
    marginBottom: 8,
    maxWidth: '45%',
  },
  mentorAvatar: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: '#0e4e96',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
  },
  mentorInitials: {
    color: '#ffffff',
    fontSize: 12,
    fontWeight: 'bold',
  },
  mentorInfo: {
    flex: 1,
  },
  mentorName: {
    fontSize: 12,
    fontWeight: '600',
    color: '#0F172A',
  },
  mentorTitle: {
    fontSize: 10,
    color: '#64748B',
  },
  cardFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: '#F1F5F9',
    paddingTop: 12,
  },
  deadlineContainer: {
    flex: 1,
  },
  deadlineLabel: {
    fontSize: 12,
    color: '#64748B',
    marginBottom: 2,
  },
  deadlineDate: {
    fontSize: 14,
    fontWeight: '500',
    color: '#0F172A',
  },
  urgentDeadline: {
    color: '#f59e0b',
  },
  pastDeadline: {
    color: '#dc2626',
  },
  applyButton: {
    backgroundColor: '#0e4e96',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 6,
  },
  disabledButton: {
    backgroundColor: '#94A3B8',
  },
  applyButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#ffffff',
  },
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  loadingText: {
    marginTop: 12,
    fontSize: 16,
    color: '#64748B',
  },
  errorContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  errorTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#dc2626',
    marginTop: 12,
    marginBottom: 8,
  },
  errorDescription: {
    fontSize: 16,
    color: '#64748B',
    textAlign: 'center',
    marginBottom: 20,
  },
  retryButton: {
    backgroundColor: '#0e4e96',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 8,
  },
  retryButtonText: {
    color: '#ffffff',
    fontSize: 16,
    fontWeight: '600',
  },
  emptyContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 40,
  },
  emptyTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#64748B',
    marginTop: 16,
    marginBottom: 8,
  },
  emptyDescription: {
    fontSize: 14,
    color: '#94A3B8',
    textAlign: 'center',
  },
});
